import { Button, type ButtonProps, forwardRef } from '@chakra-ui/react'
import { type MouseEventHandler, useCallback } from 'react'

import {
  type TrackEventExtraProps,
  type TrackEventProps,
  trackEvent as trackAnalyticsEvent,
} from '@/client/services/analytics'

const TrackEventButton = forwardRef<
  ButtonProps & {
    trackEvent: Omit<TrackEventProps, 'category'> & { extra?: TrackEventExtraProps }
  },
  'div'
>((props, ref) => {
  // Intercept onClick, and inject trackEvent functionality
  const { trackEvent, onClick, ...buttonProps } = props
  const { action, extra } = trackEvent
  const onButtonClick = useCallback<MouseEventHandler<HTMLButtonElement>>(
    (e): void => {
      trackAnalyticsEvent({ category: 'Button Click', action }, { ...extra })
      if (onClick != null) {
        onClick(e)
      }
    },
    [action, extra, onClick]
  )
  return <Button ref={ref} {...buttonProps} onClick={onButtonClick} />
})

export default TrackEventButton
